import { Box } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const containerSx = {
  overflow: 'hidden',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'top center',
  width: '100%',
  height: '100%',
};

const imgSx = {
  display: 'block',
  opacity: 1,
  width: '100%',
  height: 'auto',
  '@media (scripting: enabled)': {
    opacity: 0.01,
  },
};

class ResponsiveImage extends React.Component {
  componentDidMount() {
    if (this.img && this.img.complete) {
      this.setComplete(true);
    }
  }

  setComplete(complete) {
    this.complete = complete;
    if (this.img) {
      this.img.style.opacity = complete ? '1' : '0.01';
    }
  }

  render() {
    const { placeholder, sizes, srcSet: origSrcSet, title, alt } = this.props;
    const srcSetSizesSorted = Object.keys(origSrcSet)
      .map(k => parseInt(k, 10))
      .sort((a, b) => a - b);
    const getPath = size => origSrcSet[size];
    const srcSet = srcSetSizesSorted.map(size => `${getPath(size)} ${size}w`).join(', ');
    const src = getPath(srcSetSizesSorted[0]);
    const onLoad = () => {
      this.setComplete(true);
    };
    return (
      <Box sx={{ ...containerSx, backgroundImage: `url(${placeholder})` }}>
        <Box
          component="img"
          sx={imgSx}
          alt={alt}
          title={title}
          src={src}
          srcSet={srcSet}
          sizes={sizes}
          onLoad={onLoad}
          ref={img => {
            this.img = img;
          }}
        />
      </Box>
    );
  }
}

ResponsiveImage.defaultProps = {
  title: null,
  sizes: undefined,
};

ResponsiveImage.propTypes = {
  srcSet: PropTypes.object.isRequired,
  placeholder: PropTypes.string.isRequired,
  sizes: PropTypes.string,
  alt: PropTypes.string.isRequired,
  title: PropTypes.string,
};

export default ResponsiveImage;
